import { PERMISSION_KEYS } from './permissionKeys'

/**
 * Minimum permission(s) required before calling a backend surface from the client.
 * Use with useAppCapabilities().canCallApi() or canAccessCapability().
 */
export const API_CAPABILITY = {
  CORE_WORKBENCH: 'coreWorkbench',
  CONTENT_LIBRARY: 'contentLibrary',
  TRANSFORM: 'transform',
  ADMIN_CENTER: 'adminCenter',
  CONTENT_MANAGER: 'contentManager',
  PLATFORM_ADMIN: 'platformAdmin'
}

const CAPABILITY_PERMISSIONS = {
  [API_CAPABILITY.CORE_WORKBENCH]: [PERMISSION_KEYS.CORE_ACCESS],
  [API_CAPABILITY.CONTENT_LIBRARY]: [PERMISSION_KEYS.CONTENT_LIBRARY_ACCESS],
  [API_CAPABILITY.TRANSFORM]: [PERMISSION_KEYS.TRANSFORM_ACCESS],
  [API_CAPABILITY.ADMIN_CENTER]: [PERMISSION_KEYS.ADMIN_CENTER_ACCESS],
  [API_CAPABILITY.CONTENT_MANAGER]: [PERMISSION_KEYS.CONTENT_MANAGER_ACCESS],
  [API_CAPABILITY.PLATFORM_ADMIN]: [PERMISSION_KEYS.PLATFORM_ADMIN_ACCESS]
}

export function canAccessCapability(authStore, capability) {
  const keys = CAPABILITY_PERMISSIONS[capability]
  if (!keys?.length) return false
  return authStore.hasAnyPermission(keys)
}
